import * as React from "react";
import * as classNames from "classnames";
import {DragDropContext, Draggable, DragUpdate, Droppable} from "react-beautiful-dnd";
import LeadStatus from "../../../model/lead/LeadStatus";
import {arrayMove} from "../../../utils/ArrayUtils";

interface ComponentProps {
	/**
	 * Lead statuses.
	 */
	leadStatuses: LeadStatus[];
	/**
	 * Row click callback
	 */
	onRowClick: (leadStatus: LeadStatus) => void;
	/**
	 * Order change callback.
	 * @param {LeadStatus[]} items
	 */
	onOrderChange: (leadStatuses: LeadStatus[]) => void;
}

export default class LeadStatusesTable extends React.Component<ComponentProps, {}> {
	constructor(props: ComponentProps) {
		super(props);
		this.onDragEnd = this.onDragEnd.bind(this);
	}

	render() {
		return (
			<DragDropContext onDragEnd={this.onDragEnd}>
				<Droppable droppableId="droppable">
					{provided => (
						<div ref={provided.innerRef}>
							<table style={{tableLayout: "auto"}} className="l-table-default table-hover">
								<thead>
								<tr>
									<th>Id</th>
									<th>Label</th>
									<th>Category</th>
								</tr>
								</thead>
								<tbody style={{tableLayout: "auto"}}>
								{this.props.leadStatuses.map((item, index) => (
									<Draggable key={item.id} draggableId={item.id} index={index}>
										{(provided, snapshot) => (
											<tr onClick={() => this.props.onRowClick(item)}
												ref={provided.innerRef}
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												className={classNames({
													"c-job-status-list-item": true,
													"isDragging": Boolean(snapshot.isDragging),
												})}
												style={{...provided.draggableProps.style}}>
												<td style={{width: "20%"}}>{item.id}</td>
												<td style={{width: "40%"}}>{item.label}</td>
												<td style={{width: "40%"}}>{item.category}</td>
											</tr>
										)}
									</Draggable>
								))}
								</tbody>
							</table>
						</div>
					)}
				</Droppable>
			</DragDropContext>
		)
	}

	/**
	 * Call back on stop dragging action.
	 * @param result
	 */
	onDragEnd(result: DragUpdate) {
		// dropped outside the list
		if (!result.destination) {
			return;
		}
		this.props.onOrderChange(arrayMove(this.props.leadStatuses, result.source.index, result.destination.index, false));
	}
}
